import type { StringSchema } from 'yup';
import * as yup from 'yup';

import { CONVERSATION_TITLE_MAX_LENGTH } from '@nora-monorepo/shared';

type Translate = (key: string, params?: Array<string | number>) => string;

/**
 * Creates the yup schema for conversation titles.
 *
 * The translation function is provided by the caller so schema creation can
 * use the component's active i18n context instead of a module-level string.
 */
export function createConversationTitleSchema(
  t: Translate,
): StringSchema<string | undefined> {
  return yup
    .string()
    .trim()
    .required(t('conversation.validation.titleRequired'))
    .max(
      CONVERSATION_TITLE_MAX_LENGTH,
      t('conversation.validation.titleMaxLengthExceeded', [
        CONVERSATION_TITLE_MAX_LENGTH,
      ]),
    );
}
